import React, { useEffect, useRef } from "react";
import AFRAME from "aframe";
import { Entity } from "aframe-react";
import info from "../assets/message.png";
import dollar from "../assets/dollar_icon.svg";
import gafas_white from "../assets/icono-go.png";
import video from "../assets/video.png";
import image from "../assets/image-icon.png";
import flecha_derecha from "../assets/arrow-right.png";
import flecha_izquierda from "../assets/arrow-left.png";


export default function T360view({
  proyecto_actual,
  escena,
  seleccionarElemento,
  moverCamara,
  cargar_escena,
}) {
  const camara = useRef(null);

  const getTipo = (e) => {
    switch (e.tipo) {
      case 0:
        return "video-button";
        break;
      case 1:
        return "msg-button";
        break;
      case 2:
        return "view-button";
        break;
      case 3:
        return "image-button";
        break;
    }
  };

  useEffect(() => {
    // console.log("%c Cambio de escena", "color: red; font-size: 20px");
  }, [escena]);

  useEffect(() => {
    // console.log("%c Cambio de proyecto", "color: yellow; font-size: 20px");
    if (proyecto_actual.escenas.length > 0) {
      const indexPrincipal = proyecto_actual.escenas.findIndex(
        (e) => e.principal
      );
      cargar_escena(indexPrincipal);
    } else {
      console.log("No hay escenas");
      cargar_escena(-1);
    }
  }, [proyecto_actual]);

  useEffect(() => {
    camara.current.setAttribute("wasd-controls", { enabled: false });
    /*try{
		AFRAME.registerComponent('rotation-reader', {
			tick: function () {
				let rotation = this.el.getAttribute('rotation');

				if (rotation.x != escena.inicio.x && rotation.y != escena.inicio.y) {
					console.log('cambio en la', rotation)
				}
			}
		  });}
		  catch(e){

		  }*/
  }, []);

  return (
    <a-scene embedded>
      <a-assets>
        <img id="plus" src={info} />
        <img id="gafas" src={gafas_white} />
        <img id="playvideo" src={video} />
        <img id="image" src={image} />
        <img id="dollar" src={dollar} />
		<img id="flechaDerecha" src={flecha_derecha} alt="flechaDerecha" />
          <img
            id="flechaIzquierda"
            src={flecha_izquierda}
            alt="flechaIzquierda"
          />
      </a-assets>
      <a-sky
        id="cielo"
        src={escena.fondo}
        rotation="0 90 0"
        material="opacity: 1; transparent:true"
        animation__fade_in="property: material.opacity; from: 0; to: 1; dur: 1000; startEvents: fadein"
        animation__fade_out="property: material.opacity; from: 1; to: 0; dur: 1000; startEvents: fadeout"
      />

      <a-camera id="camara" ref={camara} rotation-reader>
        <a-entity
          position="0 0 -1"
          id="cursor"
          cursor="rayOrigin: mouse; fuse: true; fuseTimeout: 100"
          raycaster="objects: .objeto"
          material="shader:flat"
        >
          {" "}
        </a-entity>
      </a-camera>

      <a-mixin
        id="msg-button"
        geometry="primitive: circle; radius:2;"
        animation__scale="property: scale; to: 2.2 2.2 2.2; dur: 200; startEvents: mouseenter"
        animation__scale_reverse="property: scale; to: 1 1 1; dur: 200; startEvents: mouseleave"
        material="color: white; opacity: 0.5; transparent: true; shader: flat; src: #plus; side: double"
        clickeable
      ></a-mixin>
      <a-mixin
        id="dollar-button"
        geometry="primitive: circle; radius:2;"
        animation__scale="property: scale; to: 2.2 2.2 2.2; dur: 200; startEvents: mouseenter"
        animation__scale_reverse="property: scale; to: 1 1 1; dur: 200; startEvents: mouseleave"
        material="color: white; opacity: 0.5; transparent: true; shader: flat; src: #dollar; side: double"
        clickeable
      ></a-mixin>
      <a-mixin
        id="flecha-derecha-button"
        geometry="primitive: circle; radius:2;"
        // animation="property: position; from: 0 0 0; to: 0.9 0 0; dur: 1000; dir: alternate; loop: true"
        animation__scale="property: scale; to: 2.2 2.2 2.2; dur: 200; startEvents: mouseenter"
        animation__scale_reverse="property: scale; to: 1 1 1; dur: 200; startEvents: mouseleave"
        material="color: white; opacity: 1; transparent: true; shader: flat; src: #flechaDerecha; side: double"
        //text="font: #fontRoboto"
        clickeable
      ></a-mixin>
      <a-mixin
        id="flecha-izquierda-button"
        geometry="primitive: circle; radius:2;"
        // animation="property: position; from: 0 0 0; to: -0.9 0 0; dur: 1000; dir: alternate; loop: true"
        animation__scale="property: scale; to: 2.2 2.2 2.2; dur: 200; startEvents: mouseenter"
        animation__scale_reverse="property: scale; to: 1 1 1; dur: 200; startEvents: mouseleave"
        material="color: white; opacity: 1; transparent: true; shader: flat; src: #flechaIzquierda; side: double"
        //text="font: #fontRoboto"
        clickeable
      ></a-mixin>

      <a-mixin
        id="view-button"
        geometry="primitive: circle; radius:5;"
        material="opacity: 1; transparent:true; shader: flat; src: #gafas; side: double"
       // animation__scale="property: scale; to: 2.2 2.2 2.2; dur: 200; startEvents: mouseenter"
        // animation__scale_reverse="property: scale; to: 1 1 1; dur: 200; startEvents: mouseleave"
        // animation="property: rotation; dur:3000; to: 0 360 0; easing:linear; loop:true"
        clickeable
      ></a-mixin>

      <a-mixin
        id="video-button"
        geometry="primitive: circle; radius:1;"
        material="color: white; opacity: 0.5; transparent: true; shader: flat; src: #playvideo; side: double"
        animation__scale="property: scale; to: 2.2 2.2 2.2; dur: 200; startEvents: mouseenter"
        animation__scale_reverse="property: scale; to: 1 1 1; dur: 200; startEvents: mouseleave"
        border="sides: 4; radius: 25; wall: #rail;"
        clickeable
      ></a-mixin>

      <a-mixin
        id="image-button"
        geometry="primitive: circle; radius:1;"
        material="color: white; opacity: 0.5; transparent: true; shader: flat; src: #image; side: double"
        animation__scale="property: scale; to: 2.2 2.2 2.2; dur: 200; startEvents: mouseenter"
        animation__scale_reverse="property: scale; to: 1 1 1; dur: 200; startEvents: mouseleave"
        border="sides: 4; radius: 25; wall: #rail;"
        clickeable
      ></a-mixin>

      {escena.elementos.map((e, k) => (
        <Entity
          key={k}
          position={`${e.position.x} ${e.position.y} ${e.position.z}`}
          rotation={`${e.rotation.x} ${e.rotation.y} ${e.rotation.z}`}
        //   mixin={
        //     getTipo(e) === "msg-button" && e.titulo === "item"
        //       ? "dollar-button"
        //       : getTipo(e)
        //   }
		 mixin={
                      getTipo(e) === "msg-button" && e.titulo === "item"
                        ? "dollar-button"
                        : getTipo(e) === "msg-button" && e.titulo === "derecha"
                        ? "flecha-derecha-button"
                        : getTipo(e) === "msg-button" &&
                          e.titulo === "izquierda"
                        ? "flecha-izquierda-button"
                        : getTipo(e)
                    }
          id={e.id}
          class="objeto"
          events={{
            click: (e) => seleccionarElemento(e.target),
          }}
        />
      ))}
    </a-scene>
  );
}
